import React, { FunctionComponent, useMemo } from 'react';

import { Divider } from '@yandex-360/orb-components/dist/components/Divider';
import { Text } from '@yandex-360/orb-components/src/components/Text';
import { useSelector } from 'react-redux';

import {
    selectHasSummarizationBanRolePermission,
    selectHasSummarizationSettingsPermission,
} from '../../../../../../../../pages/call/features/permissions';
import { selectIsSummarizationAvailable } from '../../../../../../../../pages/call/features/summarization';
import { i18n } from '../../../../../../../helpers/i18n';
import { selectIsCalendarSummarizationFeatureEnabled } from '../../../../../../flags/selectors';
import { Heading } from '../../../heading';
import { Island } from '../../../island';
import {
    CloudRecordingTumbler,
    LocalRecordingTumbler,
    SummarizationMailRecipientTumbler,
    SummarizationTumbler,
} from '../../../tumblers';
import { CalendarSummarizationMailRecipientTumbler } from '../../../tumblers/calendar-summarization-mail-recipient-tumbler';
import css from './styles.css';

/**
 * @deprecated
 */
export const PermissionsStandard: FunctionComponent = () => {
    const isSummarizationAvailable = useSelector(selectIsSummarizationAvailable);
    const hasSummarizationSettingsPermission = useSelector(selectHasSummarizationSettingsPermission);
    const hasBanPermission = useSelector(selectHasSummarizationBanRolePermission);
    const calendarSummarizationFeatureEnabled = useSelector(selectIsCalendarSummarizationFeatureEnabled);
    const isSummarizationGroupNotEmpty = useMemo(() => {
        return isSummarizationAvailable && (hasSummarizationSettingsPermission || hasBanPermission);
    }, [hasBanPermission, hasSummarizationSettingsPermission, isSummarizationAvailable]);

    return (
        <Island className={css.permissionsWrapper}>
            <Heading
                title={i18n('settings-v2', 'permissions-header')}
                subtitle={i18n(
                    'settings-v2',
                    calendarSummarizationFeatureEnabled ? 'permissions-description-v2' : 'permissions-description'
                )}
            />
            {calendarSummarizationFeatureEnabled && (
                <Text className={css.groupTitle} typography="body-short-lg-regular">
                    {i18n('record', 'file-name-prefix')}
                </Text>
            )}
            <LocalRecordingTumbler />
            <CloudRecordingTumbler />
            {calendarSummarizationFeatureEnabled && isSummarizationGroupNotEmpty && (
                <>
                    <Divider />
                    <Text className={css.groupTitle} typography="body-short-lg-regular">
                        {i18n('settings-v2', 'meeting-summarization-v2')}
                    </Text>
                </>
            )}
            <SummarizationTumbler />
            <SummarizationMailRecipientTumbler />
            <CalendarSummarizationMailRecipientTumbler />
        </Island>
    );
};
